module.exports = __webpack_public_path__ + "img/ssa-3def.27ec57e5.svg";